import classnames from 'classnames'
import { FC, CSSProperties, ReactNode } from 'react'

import styles from './Grid.module.scss'

interface Grid extends CSSProperties {
  className?: string
  children?: ReactNode
}

const Grid: FC<Grid> = ({ className, children, ...props }) => (
  <div className={classnames(className, styles.base)} style={{ ...props }}>
    {children}
  </div>
)

export default Grid
